<template>
  <div class="footerBot">
    <footer>
      <div id="footer_top">
        <a class="logo" href="index">
          <img src="../assets/logo.png" alt="logo" />
        </a>
        <div id="social_icon2" class="phone">
          <!-- <i></i> -->
          <a>Copyright © 2020 武汉汇迪森信息技术有限公司 All Rights Reserved. 鄂ICP备20002919号-1</a>&emsp;
          <!-- <a>ICP证:沪B2-20180032-2</a> -->
        </div>
      </div>
      <div class="pc">
        <div id="footer_bottom">
          <ul>
            <router-link :to="{path: 'service', query: {categoryId: 5}}" tag="a">售后服务</router-link>
            <router-link :to="{path: 'cculture', query: {categoryId: 10}}" tag="a">关于我们</router-link>
            <router-link :to="{path: 'contactus', query: {categoryId: 13}}" tag="a">联系我们</router-link>
            <router-link :to="{path: 'joinus', query: {categoryId: 12}}" tag="a">加入我们</router-link>
            <router-link :to="{path: 'cnews', query: {categoryId: 11}}" tag="a">新闻中心</router-link>
          </ul>
        </div>
        <div class="beian">
          联系电话：027-86659180/86659183
          <br />
          <!-- <i></i> -->
          <a>Copyright © 2020 武汉汇迪森信息技术有限公司 All Rights Reserved. 鄂ICP备20002919号-1</a>&emsp;
          <!-- <a>ICP证:沪B2-20180032-2</a> -->
        </div>
      </div>

      <div class="qrcode">
        <img src="../assets/qrcode.png" alt />
        <p>微信公众号</p>
      </div>
    </footer>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "footerBot",
  data() {
    return {};
  },
  components: {},
};
</script>

<style scoped >
@media screen and (max-width: 760px) {
  footer #footer_top img {
    width: 130px;
    margin-bottom: 20px;
  }
}
@media screen and (max-width: 1200px) {
  footer #footer_top img {
    width: 130px;
  }
}
@media screen and (max-width: 760px) {
  footer {
    padding: 20px 20px !important;
  }
}
footer {
  position: relative;
  padding: 35px 50px 50px;
  background-color: #dde2e6;
  box-sizing: border-box;
  overflow: hidden;
}
footer #footer_top {
  /* width: 100%; */
  overflow: hidden;
}
footer #footer_top .logo {
  float: left;
}
footer #footer_top .logo img {
  width: 145px;
}

.phone {
  display: none;
}
i {
  display: inline-block;
  width: 14px;
  height: 18px;
  margin-right: 10px;
  background: url(../assets/icon_guohui.png);
  -webkit-background-size: cover;
  background-size: cover;
}
.phone a {
  color: #a8a8a8;
  font-size: 14px;
}
@media screen and (max-width: 760px) {
  .phone {
    display: block;
  }
}

@media screen and (max-width: 760px) {
  footer #footer_top .logo {
    float: none;
  }
}

@media screen and (max-width: 1000px) {
  footer #footer_bottom {
    position: static !important;
    text-align: left !important;
    margin-top: 10px;
  }
}
@media screen and (max-width: 760px) {
  footer .pc {
    display: none;
  }
}
footer #footer_bottom {
  position: absolute;
  top: 58px;
  right: 0;
  width: 100%;
  text-align: center;
}
footer #footer_bottom ul {
  overflow: hidden;
}

footer #footer_bottom ul a {
  font-size: 16px;
  padding: 0 10px;
  border-right: 1px solid #a8a8a8;
  color: #a8a8a8;
  line-height: 18px;
  color: #333;
}
footer #footer_bottom ul a:last-child {
  border-right: 0;
}
@media screen and (max-width: 1000px) {
  footer .beian {
    text-align: left !important;
    text-indent: 2em;
  }
}
.beian {
  width: 100%;
  text-align: center;
  color: #333;
  font-size: 14px;
  line-height: 20px;
  margin-top: 22px;
}
.beian a {
  color: #333;
  font-size: 14px;
}
@media screen and (max-width: 1000px) {
  footer .qrcode {
    display: none;
  }
}
.qrcode {
  position: absolute;
  top: 38px;
  right: 7%;
}
.qrcode img {
  width: 80px;
  height: 80px;
}
.qrcode p {
  color: #333;
  font-size: 14px;
  text-align: center;
  /* font-weight: bold; */
  line-height: 24px;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue